// Components
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import AboutSection from "./components/AboutSection";
import ServiceSection from "./components/ServiceSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import "./css/global.css";

// Styles
import "./css/global.css";
import "./App.css";
import "./css/components/ServiceSection.css";

// Hook
import useScrollAnimation from "./hook/useScrollAnimation";
import BackToTopBar from "./components/BackToTopBar";

import { Analytics } from '@vercel/analytics/react';

function App() {
    useScrollAnimation();

    return (
        <>
            {/* Navigation */}
            <Navbar />

            {/* Sections */}
            <Hero />
            <AboutSection />
            <ServiceSection />
            <ContactSection />
            <BackToTopBar />
            {/* Footer */}
            <Footer />

            <Analytics />
        </>
    );
}

export default App;
